(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer-baltistiil';
  var instance = null;

  /* ---------- money formatting (Shopify port) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || '€{{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }

    var value = '';
    var match = fmt.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  /* ---------- helpers ---------- */
  function getJSON(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function cleanPath() {
    return window.location.pathname.replace(/\/+$/, '') || '/';
  }
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- quantity tier -> discount code (2:-10%, 3:-15%, 4+:-20%) ---------- */
  function tierCodeFor(count) {
    count = parseInt(count, 10) || 0;
    if (count >= 4) return 'BALTI20';
    if (count === 3) return 'BALTI15';
    if (count === 2) return 'BALTI10';
    return null;
  }
  function applyDiscountCode(code) {
    // hitting /discount/<code> sets the cart discount cookie via the 302 Set-Cookie header;
    // redirect:'manual' avoids downloading the redirect target while the cookie is still stored
    return fetch(shopRoot() + 'discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'manual'
    }).then(function () {}, function () {});
  }

  /* ---------- detect add-to-cart from ANY source (fetch + XHR) ---------- */
  var addTimer = null;
  function onCartAdd() {
    clearTimeout(addTimer);
    addTimer = setTimeout(function () { if (instance) instance.openAfterAdd(); }, 130);
  }
  function isAddUrl(u) {
    return typeof u === 'string' && u.indexOf('/cart/add') !== -1;
  }

  (function patchFetch() {
    var orig = window.fetch;
    if (typeof orig !== 'function') return;
    function makeWrapped(fn) {
      return function () {
        var args = arguments;
        var p = fn.apply(this, args);
        try {
          var first = args[0];
          var u = first && first.url ? first.url : first;
          if (isAddUrl(u) && p && typeof p.then === 'function') {
            p.then(function (r) { if (!r || r.ok !== false) onCartAdd(); }).catch(function () {});
          }
        } catch (e) {}
        return p;
      };
    }
    var wrapped = makeWrapped(orig);
    try {
      Object.defineProperty(window, 'fetch', {
        configurable: true,
        get: function () { return wrapped; },
        set: function (v) { wrapped = makeWrapped(v); }
      });
    } catch (e) {
      window.fetch = wrapped;
    }
  })();

  (function patchXHR() {
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cdpUrl = url;
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      this.addEventListener('load', function () {
        try {
          if (isAddUrl('' + self.__cdpUrl) && self.status >= 200 && self.status < 300) onCartAdd();
        } catch (e) {}
      });
      return send.apply(this, arguments);
    };
  })();

  /* ---------- intercept cart-icon clicks -> open drawer ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(
      '#cart-icon-bubble, .header__icon--cart, a[href$="/cart"], a[href*="/cart?"], [data-cdp-open]'
    );
    if (!trigger) return;
    if (e.target.closest('[data-cdp-close]')) return;
    if (!instance) return;
    e.preventDefault();
    e.stopPropagation();
    instance.open(true);
  }, true);

  /* ---------- custom element ---------- */
  if (!customElements.get('cart-drawer-baltistiil')) {
    customElements.define('cart-drawer-baltistiil', class extends HTMLElement {
      connectedCallback() {
        instance = this;
        this.moneyFormat = this.dataset.moneyFormat || '€{{amount}}';
        this._appliedCode = undefined;
        this.bind();
        this.loadUpsell();
        // ensure the right tier code is on the cart even before the drawer is opened
        var self = this;
        getJSON('/cart.js').then(function (c) {
          self.setCount(c.item_count);
          self.syncDiscount(c.item_count);
        }).catch(function () {});
      }

      bind() {
        var self = this;

        // delegated clicks within the drawer
        this.addEventListener('click', function (e) {
          if (e.target.closest('[data-cdp-close]')) { self.close(); return; }

          var qtyBox = e.target.closest('.cdp-qty');
          if (qtyBox) {
            var key = qtyBox.getAttribute('data-key');
            var valEl = qtyBox.querySelector('.cdp-qty__val');
            var cur = parseInt(valEl ? valEl.textContent : '1', 10) || 1;
            if (e.target.closest('[data-cdp-plus]')) { self.changeQty(key, cur + 1); return; }
            if (e.target.closest('[data-cdp-minus]')) { self.changeQty(key, Math.max(cur - 1, 0)); return; }
          }

          var remove = e.target.closest('[data-cdp-remove]');
          if (remove) { self.changeQty(remove.getAttribute('data-key'), 0); return; }

          var add = e.target.closest('[data-cdp-add]');
          if (add) { self.addUpsell(add); return; }
        });

        // update the displayed price when an upsell size is changed
        this.addEventListener('change', function (e) {
          var sel = e.target.closest('[data-cdp-size]');
          if (!sel) return;
          var card = sel.closest('.cdp-up-card');
          if (!card) return;
          var opt = sel.options[sel.selectedIndex];
          var price = parseInt(opt.getAttribute('data-price'), 10);
          var cmp = parseInt(opt.getAttribute('data-compare'), 10);
          var priceEl = card.querySelector('.cdp-up-card__price');
          if (priceEl && !isNaN(price)) {
            var html = formatMoney(price, self.moneyFormat);
            if (cmp && cmp > price) html = '<s>' + formatMoney(cmp, self.moneyFormat) + '</s>' + html;
            priceEl.innerHTML = html;
          }
        });

        // close on ESC
        document.addEventListener('keyup', function (e) {
          if (e.key === 'Escape' && self.classList.contains('is-open')) self.close();
        });
      }

      get content() { return document.getElementById('CartDrawerBaltistiilContent'); }

      open(refresh) {
        this.classList.add('is-open');
        document.documentElement.classList.add('cdp-lock');
        if (refresh) this.refresh();
      }

      openAfterAdd() {
        this.open(false);
        this.refresh();
      }

      close() {
        this.classList.remove('is-open');
        document.documentElement.classList.remove('cdp-lock');
      }

      replaceContent(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawerBaltistiilContent');
        if (fresh && this.content) this.content.innerHTML = fresh.innerHTML;
      }

      refresh() {
        var self = this;
        return getJSON('/cart.js')
          .then(function (cart) {
            self.setCount(cart.item_count);
            return self.syncDiscount(cart.item_count);
          })
          .then(function () { return self.render(); })
          .then(function () { self.loadUpsell(); })
          .catch(function () {});
      }

      render() {
        var self = this;
        return getJSON(cleanPath() + '?sections=' + SECTION_ID)
          .then(function (data) {
            if (data && data[SECTION_ID]) self.replaceContent(data[SECTION_ID]);
          });
      }

      // apply the discount code matching the current quantity tier; only fires when the tier changes
      syncDiscount(count) {
        var target = tierCodeFor(count);
        if (target === this._appliedCode) return Promise.resolve();
        this._appliedCode = target;
        if (!target) return Promise.resolve();
        return applyDiscountCode(target);
      }

      changeQty(key, qty) {
        if (!key) return;
        var self = this;
        postJSON('/cart/change.js', { id: key, quantity: qty })
          .then(function (cart) {
            var count = (cart && typeof cart.item_count !== 'undefined') ? cart.item_count : 0;
            self.setCount(count);
            return self.syncDiscount(count);
          })
          .then(function () { return self.render(); })
          .then(function () { self.loadUpsell(); })
          .catch(function () { self.refresh(); });
      }

      addUpsell(btn) {
        var card = btn.closest('.cdp-up-card');
        var sizeSel = card ? card.querySelector('[data-cdp-size]') : null;
        var id = sizeSel ? sizeSel.value : btn.getAttribute('data-id');
        if (!id) return;
        var self = this;
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = '...';
        postJSON('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] })
          .then(function () { return self.refresh(); })
          .catch(function () {})
          .then(function () { btn.disabled = false; btn.textContent = label; });
      }

      setCount(n) {
        document.querySelectorAll(
          '.cart-count-bubble span:first-child, #cart-icon-bubble .cart-count-bubble span:first-child, [data-cart-count], .cart-count'
        ).forEach(function (el) {
          if (el.hasAttribute && el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', n);
          el.textContent = n;
        });
      }

      loadUpsell() {
        var wrap = this.querySelector('[data-cdp-upsell]');
        var list = this.querySelector('[data-cdp-upsell-list]');
        if (!wrap || !list) return;
        var self = this;
        getJSON('/cart.js').then(function (cart) {
          if (!cart.items || !cart.items.length) { wrap.hidden = true; return; }
          var pid = cart.items[0].product_id;
          var inCart = cart.items.map(function (i) { return i.product_id; });
          return getJSON('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
            .then(function (d) {
              var prods = (d.products || []).filter(function (p) {
                return inCart.indexOf(p.id) === -1 && p.available;
              }).slice(0, 3);
              if (!prods.length) { wrap.hidden = true; return; }
              list.innerHTML = prods.map(function (p) { return self.upsellCard(p); }).join('');
              wrap.hidden = false;
            });
        }).catch(function () { wrap.hidden = true; });
      }

      upsellCard(p) {
        var v = null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) { v = p.variants[i]; break; }
        }
        if (!v) v = p.variants[0];
        var img = (p.featured_image || (p.images && p.images[0])) || '';
        var priceHtml = formatMoney(v.price, this.moneyFormat);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceHtml = '<s>' + formatMoney(v.compare_at_price, this.moneyFormat) + '</s>' + priceHtml;
        }

        var sizeHtml = '';
        if (p.variants.length > 1) {
          var opts = '';
          for (var j = 0; j < p.variants.length; j++) {
            var vr = p.variants[j];
            var sel = vr.id === v.id ? ' selected' : '';
            var dis = vr.available ? '' : ' disabled';
            var lbl = escapeHtml(vr.title) + (vr.available ? '' : ' — pole');
            opts +=
              '<option value="' + vr.id + '"' +
              ' data-price="' + vr.price + '"' +
              ' data-compare="' + (vr.compare_at_price || '') + '"' +
              sel + dis + '>' + lbl + '</option>';
          }
          sizeHtml = '<select class="cdp-up-card__size" data-cdp-size aria-label="Suurus">' + opts + '</select>';
        }

        return (
          '<div class="cdp-up-card">' +
            (img ? '<img class="cdp-up-card__img" src="' + img + '" alt="" loading="lazy">' : '') +
            '<div class="cdp-up-card__main">' +
              '<p class="cdp-up-card__title">' + escapeHtml(p.title) + '</p>' +
              '<p class="cdp-up-card__price">' + priceHtml + '</p>' +
              '<div class="cdp-up-card__buy">' +
                sizeHtml +
                '<button type="button" class="cdp-up-card__add" data-cdp-add data-id="' + v.id + '">Lisa</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
})();
